var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBackToTop),expression:"showBackToTop"}],staticClass:"back-to-top-btn",style:(_vm.buttonStyle),attrs:{"type":"primary","size":"small"},on:{"click":_vm.scrollToTop}},[_c('van-icon',{attrs:{"name":"upgrade"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189ad734","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commonCom/BackToTopCom.vue
// module id = null
// module chunks = 